function TableUsers({ users, onAction , hasManagementPermissions}) {
  const ENABLE_NEW_USER = false; // TODO: cambiare per ora gli utenti sono inseriti altrove (va comunque implementato)
  return (
    <div className="ventana_resultado_visible">
      <div className="tabla">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Usuario</th>
              <th>Email</th>
              <th>Activo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.COD_ID || user.USER}>
                <td className="resuelta">
                  <i className="bi bi-check2-circle"></i>
                </td>
                <td>{user.USER}</td>
                <td>{user.EMAIL}</td>
                <td>{user.ACTIVO === 1 || user.ACTIVO === "1" ? "Sí" : "No"}</td>
                <td>
                  <i className="bi bi-three-dots-vertical">
                    <div className="acciones">
                      <span
                        className="item_acciones"
                        onClick={() => onAction("cambiar-password", user.COD_ID)}
                      >
                        Cambio / Blanqueo PASS
                      </span>
                      <span
                        className="item_acciones"
                        onClick={() => onAction("modificar-usuario", user.COD_ID)}
                      >
                        Modificar Usuario
                      </span>
                      <span
                        className={`item_acciones ${!hasManagementPermissions ? "disable" : ""}`}
                        onClick={() => onAction("permisos-usuario", user.COD_ID)}
                      >
                        Grupos
                      </span>
                      <span
                        className="item_acciones disable"
                        title="Función no disponible actualmente"
                      >
                        Borrar usuario
                      </span>
                    </div>
                  </i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {
          ENABLE_NEW_USER && (
            <div className="input-group_2">
              <span
                className="boton_opciones disable"
                title="Función no disponible actualmente"
              >
                Nuevo usuario
              </span>
            </div>
          )
        }
        
      </div>
    </div>
  );
}

export default TableUsers;